module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.10960/img/partner-award-badge.svg"